import React, { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import './styles.css';

interface Props {
    columns: any[];
    rows: any[];
    onChangeItems?: (items: any[]) => void;
    deferPositionUpdate?: boolean;
}

export const DraggableListView = ({
    columns,
    rows,
    onChangeItems,
    deferPositionUpdate,
}: Props) => {
    const [items, setItems] = React.useState<any[]>([]);
    const [draggingItem, setDraggingItem] = useState<any>();

    const handleDragStart = (e: any, item: any) => {
        setDraggingItem(item);
        e.dataTransfer.setData('text/plain', '');
    };

    const handleDragEnd = () => {
        setDraggingItem(null);
    };

    const handleDragOver = (e: any) => {
        e.preventDefault();
    };

    const handleDrop = (e: any, targetItem: any) => {
        if (!draggingItem || !onChangeItems) return;

        const newItems = JSON.parse(JSON.stringify(items));
        const newDrag = newItems.find(
            (item: any) => draggingItem.id == item.id
        );
        const newTarget = newItems.find(
            (item: any) => targetItem.id == item.id
        );

        const currentIndex = newItems.indexOf(newDrag);
        const targetIndex = newItems.indexOf(newTarget);

        if (currentIndex !== -1 && targetIndex !== -1) {
            newItems.splice(currentIndex, 1);
            newItems.splice(targetIndex, 0, newDrag);
            newItems.forEach(
                (item: any, index: number) => (item.position = index)
            );

            if (!deferPositionUpdate) {
                setItems(newItems);
            }

            onChangeItems(newItems);
        }
    };

    useEffect(() => {
        setItems(rows || []);
    }, [rows]);

    return (
        <Grid
            border="1px solid #E0E0E0"
            borderRadius="4px"
            overflow="overlay"
            maxHeight="100vh"
        >
            <Grid overflow="hidden" minWidth="100%" display="inline-block">
                <Grid
                    border="1px solid #E0E0E0"
                    overflow="hidden"
                    minWidth="100%"
                >
                    <Grid display="flex">
                        {columns?.map((col, i) => (
                            <Grid
                                key={`COL-${i}`}
                                minWidth={col.minWidth}
                                flex={col.flex || 1}
                                display="flex"
                                alignItems="center"
                                height="56px"
                            >
                                <Typography
                                    textOverflow="ellipsis"
                                    overflow="hidden"
                                    whiteSpace="nowrap"
                                    fontWeight={500}
                                    mx="10px"
                                    fontSize="0.875rem"
                                >
                                    {col.headerName}
                                </Typography>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
                {items.map((item: any) => (
                    <Grid
                        key={`COL-${item.id}`}
                        draggable="true"
                        onDragStart={(e: any) => handleDragStart(e, item)}
                        onDragEnd={handleDragEnd}
                        onDragOver={handleDragOver}
                        onDrop={(e: any) => handleDrop(e, item)}
                        border="1px solid #E0E0E0"
                        overflow="hidden"
                        minWidth="100%"
                        bgcolor={
                            draggingItem?.id === item.id
                                ? '#D32F2F'
                                : 'transparent'
                        }
                        className="row-drag"
                    >
                        <Grid display="flex">
                            {columns?.map((col, i) => (
                                <Grid
                                    key={`CELL-${i}`}
                                    minWidth={col.minWidth}
                                    flex={col.flex || 1}
                                    display="flex"
                                    alignItems="center"
                                    height="56px"
                                >
                                    {col.renderCell ? (
                                        col.renderCell({
                                            id: item.id,
                                            row: item,
                                        })
                                    ) : (
                                        <Typography
                                            textOverflow="ellipsis"
                                            overflow="hidden"
                                            whiteSpace="nowrap"
                                            fontWeight={500}
                                            mx="10px"
                                            fontSize="0.875rem"
                                        >
                                            {item[col.field]}
                                        </Typography>
                                    )}
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                ))}
            </Grid>
        </Grid>
    );
};

export default DraggableListView;
